export const FAMILY_ROLE_INTERNAL_CODES = {
  STUDENT: "STUDENT",
  EMERGENCY_CONTACT: "EMERGENCY_CONTACT",
  INQUIRER: "INQUIRER",
  FAMILY_MEMBER: "FAMILY_MEMBER",
  PAYOR: "PAYOR",
  PRIMARY_CONTACT: "PRIMARY_CONTACT"
} as const;

type FamilyRoleLike = {
  value: string | number;
  isActive?: boolean;
  internalCode?: string;
};

export const findFamilyRoleIdByInternalCode = (
  roles: FamilyRoleLike[] = [],
  internalCode: string,
  options?: { activeOnly?: boolean }
) => {
  const role = roles.find(item => {
    if (item.internalCode !== internalCode) {
      return false;
    }
    if (options?.activeOnly) {
      return item.isActive !== false;
    }
    return true;
  });

  if (!role) {
    return undefined;
  }

  return `${role.value}`;
};
